import PropTypes from 'prop-types';
import { Center, Box, Image } from '@chakra-ui/react';

/**
 * CategoryImage component for displaying category thumbnails
 * Used as fallback when courses don't have thumbnails
 * Displays custom thumbnail centered like CourseImage component
 * Maintains consistent 16:9 aspect ratio for all category images
 *
 * @param {string} name - Category name for alt text
 * @param {string} image - Category thumbnail image path
 */
function CategoryImage({ name, image, ...rest }) {
  const baseFileUrl = process.env.REACT_APP_FILE_URL;

  return (
    <Box
      {...rest}
      pos="relative"
      aspectRatio={16 / 9}
      w="100%"
      bg="black"
      _before={{
        content: '""',
        bgImage: require('assets/default-course.jpg'),
        bgSize: 'cover',
        pos: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        opacity: 0.2,
      }}
    >
      <Center h="100%" w="100%">
        {image && (
          <Image
            src={
              image?.startsWith('data:') || image?.startsWith('blob:')
                ? image
                : `${baseFileUrl}${image}`
            }
            maxW="80%"
            maxH="80%"
            alt={name}
            objectFit="contain"
          />
        )}
      </Center>
    </Box>
  );
}

CategoryImage.defaultProps = {
  name: null,
  image: null,
};

CategoryImage.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
};

export default CategoryImage;
